// Create a random alpha numeric string of length `length`
//
const makeRandomAlphaNumeric = function(strLength) {
  // no vowels because we don't want accidental bad words
  var possible = 'bcdfghjklmnpqrstvwxz23456789';
  var randCharsArray = [];
  for (var i=0; i<strLength; i++){
    randCharsArray.push(possible.charAt(Math.floor(Math.random() * possible.length)));
  }
  return randCharsArray.join('');
};



export {
  makeRandomAlphaNumeric
};